module.exports = __webpack_public_path__ + "img/girl-head-back.4ba35631.png";